import React from "react";
import { observer } from "mobx-react-lite";
import EventCard from "./EventCard";
import EventButton, {
  EventButtonVariant,
} from "../../shared/components/EventButton";
import CountdownTimer from "../../shared/components/CountdownTimer";

interface SetupsCardProps {
  eventDateTime: Date;
  hasGuests: boolean;
  hasGeneratedSetups: boolean;
  onCreateManualSetups: () => void;
  onGenerateSetups?: () => void;
  onSeeSetups?: () => void;
  onManageManualSetups?: () => void;
}

const SetupsCardComponent: React.FC<SetupsCardProps> = ({
  eventDateTime,
  hasGuests,
  hasGeneratedSetups,
  onCreateManualSetups,
  onGenerateSetups,
  onSeeSetups,
  onManageManualSetups,
}) => {
  const canGenerateSetups =
    eventDateTime && eventDateTime.getTime() - Date.now() <= 30 * 60 * 1000; // 30 minutes

  if (!hasGuests) {
    return (
      <EventCard title="SETUPS">
        <p className="text-white/80 text-md text-center">
          Generate setups within 30 minutes of the event, when all your guests
          are signed up.
        </p>

        <div className="w-full mt-4 text-center">
          <CountdownTimer eventDateTime={eventDateTime} />
        </div>

        <EventButton
          onClick={onCreateManualSetups}
          variant={EventButtonVariant.TRANSPARENT}
          className="mt-4 w-full"
          icon="🤝"
        >
          Create manual setups
        </EventButton>
      </EventCard>
    );
  }

  return (
    <EventCard title="SETUPS" centerContent>
      <p className="text-white/80 text-center mb-4">
        Generate setups within 30 minutes of the event, when all your guests are
        signed up.
      </p>

      {hasGeneratedSetups && onSeeSetups && (
        <EventButton
          onClick={onSeeSetups}
          variant={EventButtonVariant.PRIMARY_BLACK}
          className="mt-4 w-full mb-4"
          icon="👀"
        >
          See setups
        </EventButton>
      )}

      {!hasGeneratedSetups && onGenerateSetups && (
        <EventButton
          onClick={onGenerateSetups}
          disabled={!canGenerateSetups}
          variant={
            canGenerateSetups
              ? EventButtonVariant.GRADIENT
              : EventButtonVariant.DISABLED
          }
          className="mt-4 w-full mb-4"
          icon="❤️‍🔥"
        >
          Generate setups
        </EventButton>
      )}

      {onManageManualSetups && !hasGeneratedSetups && (
        <EventButton
          onClick={onManageManualSetups}
          variant={EventButtonVariant.TRANSPARENT}
          icon="📋"
        >
          Manage manual setups
        </EventButton>
      )}
    </EventCard>
  );
};

SetupsCardComponent.defaultProps = {
  onGenerateSetups: undefined,
  onSeeSetups: undefined,
  onManageManualSetups: undefined,
};

const SetupsCard = observer(SetupsCardComponent);

export default SetupsCard;
